import { render, staticRenderFns } from "./profileDropdown.vue?vue&type=template&id=24c535ca&scoped=true"
import script from "./profileDropdown.vue?vue&type=script&lang=js"
export * from "./profileDropdown.vue?vue&type=script&lang=js"
import style0 from "./profileDropdown.vue?vue&type=style&index=0&id=24c535ca&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24c535ca",
  null
  
)

export default component.exports